import { render, staticRenderFns } from "./PersonalStory.vue?vue&type=template&id=4e4039b8&scoped=true"
import script from "./PersonalStory.vue?vue&type=script&lang=js"
export * from "./PersonalStory.vue?vue&type=script&lang=js"
import style0 from "./PersonalStory.vue?vue&type=style&index=0&id=4e4039b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4039b8",
  null
  
)

export default component.exports